import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */
i18next.addResources(locales.EN, 'MAINTENANCE_PAGE', {
  TITLE: 'Under Construction',
  SUBTITLE:
    'The Beneemeth site is currently undergoing scheduled maintenance. We will be back online shortly.',
  PATIENCE_TEXT: 'We appreciate your patience and apologize for any inconvenience.',
  CONTACT_TITLE: 'Need urgent help?',
  CONTACT_SUBTITLE:
    'Our team is still operational. Send us a message and we will get back to you shortly.',
});

/* ------------------------------------- Spanish ------------------------------------- */
i18next.addResources(locales.ES, 'MAINTENANCE_PAGE', {
  TITLE: 'Estamos trabajando',
  SUBTITLE:
    'El sitio de Beneemeth se encuentra actualmente en mantenimiento programado. Volveremos a estar en línea muy pronto.',
  PATIENCE_TEXT: 'Agradecemos su paciencia y pedimos disculpas por las molestias.',
  CONTACT_TITLE: '¿Necesitas ayuda urgente?',
  CONTACT_SUBTITLE:
    'Nuestro equipo sigue operativo. Envíanos un mensaje y te responderemos a la brevedad.',
});
